import React from 'react';
import * as Styled from './styled';
import { colors } from '@/styles';

import SyntaxHighlighter from 'react-syntax-highlighter';
import { github } from 'react-syntax-highlighter/dist/esm/styles/hljs';

import { IRepositoryEntry, IRepositoryFile } from '@/types';
import MarkdownFileView from '@/components/Repository/FileView/MarkdownFileView';
import JsonFileView from '@/components/Repository/FileView/JsonFileView';
import NotebookFileView from '../NotebookFileView';

const tryParseJSONObject = (jsonString: string) => {
  try {
    var o = JSON.parse(JSON.stringify(jsonString));

    // Handle non-exception-throwing cases:
    // Neither JSON.parse(false) or JSON.parse(1234) throw errors, hence the type-checking,
    // but... JSON.parse(null) returns null, and typeof null === "object",
    // so we must check for that, too. Thankfully, null is falsey, so this suffices:
    if (o && typeof o === 'object') {
      return o;
    }
  } catch (e) {}

  return false;
};

const CodeView: React.FC<{ language: string; code: string }> = ({ language, code }) => {
  return (
    <SyntaxHighlighter
      showLineNumbers
      lineNumberContainerStyle={{ paddingRight: 20 }}
      lineNumberStyle={{ color: colors.secondary.lightGray3 }}
      language={language}
      style={github}
    >
      {code}
    </SyntaxHighlighter>
  );
};

const TextFileView: React.FC<{ entry: IRepositoryEntry; file: IRepositoryFile }> = ({ entry, file }) => {
  if (file.mime_type === 'text/markdown' || entry.extension === 'mdx') {
    return <MarkdownFileView file={file} />;
  }

  if (entry.extension === 'py') {
    return <CodeView language="python" code={file.data} />;
  }

  if (entry.extension == 'ipynb') {
    return <NotebookFileView file={file} />;
  }
  // Sometimes JSON files are not marked as JSON, so we try to parse them to avoid blowing up the renderer
  // In the case where it is json, we render it as code
  const parsedJSON = tryParseJSONObject(file.data);
  return parsedJSON ? <JsonFileView file={file} /> : <Styled.TextFileView>{file.data}</Styled.TextFileView>;
};

export default TextFileView;
